/**
 * created by tian ruo jun
 * 2022/04/15
 * 稿件编辑器
 * 用于通讯员或审核人打开被编辑打回的1.1.1版本待办稿件，与网站编辑器webEditor相比：这个编辑器没有右侧设置模块
 */
import React, {Component} from 'react';
import {Input, message} from "antd";
import Editor from '../Editor'
import {base64Encode} from "../../../utils";
import WebEditor from "../webEditor/WebEditor";
import ButtonList from "../components/activitiAndBtn/ButtonList";
import SyncModal from "../../components/syncModal/syncModal";
import LinkCheck from "../components/pluginsSpace/linkCheck/linkCheck";
import {removeContentSecurity} from "../floatTool/securityCheck";
import {getInfoFromLocalStorage} from "../../../actions";
import {systemBaseEvent} from "../../../base/baseEvent";
import EditorInformation from "../components/EditorInformation";
import {formItemSizeConfig, informationConfig} from "../webEditor/form/information-config";


export default class WebStoryEditor extends WebEditor {
    static defaultProps = {};
    static propTypes = {};


    /**设置流程配置*/
    async initActivitiConfig(story,call) {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        this.state.id = id;
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        if(
            id &&
            (!story.id || story.id!=id)
        ) {
            return false
        }
        let noPublishConfig = this.sysConfigGetValueByKey("materialCenter.publishBtn.exclude", "已发布");
        let mustNotShowPublishBtn1 = (story.statusName && noPublishConfig.indexOf(story.statusName)>-1)?false :true
        let mustNotShowPublishBtn2 = that.urlParams && that.urlParams.mustNotShowPublishBtn ? that.urlParams.mustNotShowPublishBtn : false;
        // 判断操作权限start
        let showBtnFlag = false;
        let currentMediaList = getInfoFromLocalStorage("currentMediaList");
        if(!currentMediaList) {
            currentMediaList = await this.getCurrentMediaList()
        }
        if(currentMediaList && currentMediaList.length) {
            if(currentMediaList.find(item=>item&&item.mediaList&&item.mediaList.find(item2=>item2.id===this.state.mediaId))){
                showBtnFlag = true;
            }
        }
        // 判断操作权限end
        // 重置流程条件start
        let againFlag = false;
        if(!id && this.state.storyId) {
            // 当前稿件无id，但是投稿稿件存在id，需要用旧id重启流程
            againFlag = true;
            id = this.state.storyId;
        }
        let reloadStatus = this.sysConfigGetValueByKey("webNews.activiti.reload.status", "");
        // if(story.statusName && reloadStatus.indexOf(story.statusName) > -1) { // 弃用状态重启审核流
        //     againFlag = true;
        // }
        // 重置流程条件end
        this.state.activityOption = {
            id,//流程id
            activitiConf: this.urlParams ? {type: this.urlParams.activitiConfName} : null,//流程conf
            pojoName: 'storyToWebNews',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag:true,//是否显示流程按钮
            againFlag: false,//重置流程的判断条件
            showAfterFuns: {
                // call({code: 1});
                // call({code: 0, log: "非投稿稿件！"});
                // call({code: -1, log: "未获取到采访任务信息，请重新打开再试！"});
                /**
                 * 是否是投稿稿件来源（弃用，返回写稿人按钮显隐判定）
                 */
                fromContribute: (item, call) => {
                    if(that.state.operateType && that.state.operateType === "contribute") {
                        call({code: 1});
                    } else {
                        call({code: 0, log: "非投稿稿件！"});
                    }
                },
                /**
                 * 弃用
                 */
                abandon: (item, call) => {
                    if(id) {
                        call({code: 1});
                    } else {
                        call({code: 0, log: "新增稿件没有弃用权限！"});
                    }
                },
                /**
                 * 是否显示撤回按钮
                 */
                callBackBtnShow: (item, call) => {
                    // 素材中心稿件标题进入的稿件
                    if(that.state.operateType && that.state.operateType === "contribute") {
                        let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.goBack.states", "已返回写稿人,返回写稿人");
                        // 稿件状态为返回写稿人
                        if(story && story.statusName && activitiConfName.includes(story.statusName)) {
                            call({code: 0, log: "不显示撤回按钮！"});
                            return
                        }
                    }
                    call({code: 1});
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                setSourceUser: (activiti, buttonConf, call) => {
                    let myId = (window.currentUser && window.currentUser.account) ? window.currentUser.id : "";
                    if (myId === this.webStory.creator) {
                        message.warning("当前稿件写稿人与当前操作人是同一人，无需返回");
                        window.loading.hide();
                        return false;
                    }
                    activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                        id: this.webStory.creator,
                        name: this.webStory.creatorName
                    }];
                    call({code: 1, log: "查询到返回者为：" + this.webStory.creator});
                },
                /**
                 * 撤稿前置js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callActRevert: function (activiti, buttonConf, call) {
                    activiti.terminate.call(activiti, function (res) {
                        if (res == true) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if(res){
                                    message.success("流程已撤回，稿件变为草稿状态", 1, ()=>{
                                        activiti.submitOK();
                                    });
                                }
                            })
                        }
                    });
                },
            },//流程按钮事件前置js
            saveFunction: that.saveStory,//稿件保存方法
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.refresh(activiti)
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            showRemarks: (remarks) => {
                if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver:(btns)=>{
                this.activitiBtns = btns;
                this.setState({});
            },
            // 控制前端发布按钮的显隐
            // mustNotShowPublishBtn: (mustNotShowPublishBtn1 || mustNotShowPublishBtn2) ? true : false,
            showBtnIcon: true,
            btnType: "editor",
            mustNotShowPublishBtn: true,
            checkForm: that.checkForm
        };
        this.setState({});
        call&&call(this.state.activityOption)
    }

    componentWillMount() {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        let urlParams = this.urlParams;
        if(!id && !(urlParams && urlParams.storyId)) {
            this.initActivitiConfig({});
        }
    }

    /**
     * 设置父页面传过来的参数作为编辑器中的数据回显
     */
    initParentData() {
        if (this.urlParams) {
            this.state.operateType = this.urlParams.operateType;
            this.state.storyId = this.urlParams.storyId;
            if(this.urlParams.webStory){
                this.state.webStory = this.urlParams.webStory;
                let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
                if(!id) {
                    this.setStoryByData(this.state.webStory);
                }
            }
            this.setState({});
        }
    };

    getActBtnListData (){
        let buttonListData = super.getActBtnListData();
        if(!buttonListData){
            return buttonListData;
        }
        buttonListData.showPrint = false;
        return buttonListData;
    }

    // 渲染稿件编辑器
    render() {
        let that = this;
        return (
            <Editor
                // Editor组件暴露
                ref={(Editor) => {this.Editor = Editor}}
                // 动态参数（传递到子组件中）
                dynamicParams={{editorId:this.state.id}}
                // 流程按钮组件
                editorActBtn={this.renderActBtn()}
                // 稿件基本信息组件
                editorInformation={this.renderInformation()}
                // 稿件栏目设置模块  只有投稿箱的数据才显示右侧信息
                editorRightModule={null}
                // 编辑器加载完毕的回调
                onEditorLoadOver={()=>{
                    // 向父页面请求媒体参数或稿件参数
                    // this.callPostMessage({
                    //     message: "请求媒体参数"
                    // });
                    window.ueditor.afterSaveDataFun = [];
                    window.ueditor.addAfterSaveDataFun = function(fun){
                        window.ueditor.afterSaveDataFun.push(fun);
                    };
                    //接收参数去渲染数据  这里只能放在这里，因为必须等到编辑器加载完成了之后，才要把内容放在编辑器中
                    this.initParentData();
                    //接收id去渲染数据
                    this.getStoryById()
                }}
                // 编辑器内容改变的回调
                onEditorContentChange={(content)=>{
                    this.setState({contentText:this.getEditContentText()})
                }}
                // 基本信息展开和关闭的回调
                onInformationStatusCallBack={(status) => {this.setState({informationStatus: status})}}
                // 表单展开状态
                informationStatus={this.state.informationStatus}
                // 右侧展开状态
                publishSettingStatus={false}
                // 编辑器工具栏上的插件配置
                pluginsSpaceConfig={["linkCheck", "securityPlugin","storyResource","storyImport"]}
            />
        )
    }

    // 渲染稿件基本信息
    renderInformation = () => {
        return(
            <EditorInformation
                // 配置文件（输入框占比）
                informationConfig={informationConfig}
                // 配置文件（输入框大小）
                formItemSizeConfig={formItemSizeConfig}
                // 基本信息展开状态
                informationStatus={this.state.informationStatus}
                // 编辑器内容
                contentText={this.state.contentText}
                // 标题的加号
                titleAddOrMinus={(call) => {
                    this.titleAddOrMinus(call)
                }}
                onLinkCheckedCall={(status)=>{
                    this.setState({editorShowStatus:status})
                }}
                formItemOnChange={(key, value)=>{//表单内容变化时通知
                    systemBaseEvent.asyncExec("editorInformationItemChange", {key, value});
                }}
                // 点击标题
                dynamicParams={{
                    editorId: this.state.id,
                    mediaId: this.state.mediaId,
                    treeId: this.state.treeId,
                    contentId: this.state.contentId,
                }}
                ref={(ref) => {
                    this.editorInformation = ref;
                    window.ueditor.getInformation = (check)=>this.editorInformation.getInformation(check);
                    window.ueditor.delAttachByMd5 = (md5)=>this.editorInformation.delAttachByMd5(md5);
                    window.ueditor.setFocus = (labelKey)=>this.editorInformation.setFocus(labelKey);
                    window.ueditor.informationSelect = (labelKey,sIndex,eIndex) => this.EditorInformation.selectText(labelKey,sIndex,eIndex);
                }}
            />
        )
    };

    getActBtnListData = () => {
        let data = super.getActBtnListData();
        if(data && data.showPreview) {
            data.showPreview = false;
        }
        return data
    };

    checkForm = (activiti, call) => {
        //编辑器内容============start
        let content = this.getEditContent();
        if(!content) {
            window.loading.hide();
            message.warning("请填写内容！");
            return false
        }
        if(content.indexOf("wordimg.png") !== -1){
            window.loading.hide();
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            return false
        }
        //编辑器内容============end

        // 获取基础属性==============start
        let currentInformation = this.getCurrentInformation();
        if(!currentInformation) {// 基本信息校验
            window.loading.hide();
            return false
        }
        call&&call()
    };

    /**
     * 稿件保存
     */
    saveStory = (activiti, call) => {
        //编辑器内容============start
        let content = this.getEditContent();
        if(!content) {
            window.loading.hide();
            message.warning("请填写内容！");
            call && call(false);
            return false
        }
        if(content.indexOf("wordimg.png") !== -1){
            window.loading.hide();
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            call&&call(false);
            return false
        }
        //编辑器内容============end

        // 获取基础属性==============start
        let currentInformation = this.getCurrentInformation();
        if(!currentInformation) {// 基本信息校验
            window.loading.hide();
            call&&call(false);
            return false
        }
        // let {information, dynamicParams} = currentInformation;
        // dynamicParams = dynamicParams || {};
        if(this.webStory.variableFields){
            currentInformation.variableFields.formatId = this.webStory.variableFields.formatId;
        }
        // 获取基础属性==================end

        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';//稿件id
        // 获取发布设置end

        let that = this;
        window.loading.hide();
        this.LinkCheck.show(content,(res)=>{
            window.loading.show();
            if(res) {
                if(res.content) {
                    this.setContent(res.content);
                }
                if(res.status) {
                    // 稿件数据 start
                    let params = {
                        ...this.webStory,
                        // // 附件
                        // "attach": currentInformation.attach,
                        // "title": currentInformation.title,
                        // "titlePic": currentInformation.titlePic,
                        // // 可变字段
                        // "variableFields": currentInformation.variableFields,
                        // // 站群字段
                        // "wbextends": currentInformation.wbextends,
                        ...currentInformation,
                        // 正文
                        "content": base64Encode(removeContentSecurity(res.content || content)),
                        // 资料源id int
                        "id": id,
                    };
                    // 稿件数据 end
                    let url = '/cm-sites-pms/website/news/save';
                    // 获取发布等状态
                    let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
                    let autoSaveStatsConfName = that.sysConfigGetValueByKey("webNew.activiti.autoSave.states", "发布,已发布,修改完成并提交");
                    let autoSaveStats = statusNameTemp && autoSaveStatsConfName.indexOf(statusNameTemp)>-1;
                    if(autoSaveStats) {
                        url = '/cm-sites-pms/website/news/autoSave';
                    }
                    systemBaseEvent.asyncExec("editorUpdateData");
                    if(this.publishData?.dbUpdateTime) {
                        // 已经保存过，再次进行保存，需要更新保存时间
                        params.dbUpdateTime = this.publishData.dbUpdateTime
                    }
                    this.request({
                        url,
                        method: 'POST',
                        body: params,
                        contentType: 'json',
                        callBack: async (res) => {
                            if (res) {
                                // 备注，这里必须这样写，稿件保存时不会回显同步投递的参数，但是发布时需要
                                this.publishData = {...params,...res,content: base64Encode(removeContentSecurity(res.content))};
                                this.state.id = res.id;
                                window.loading.hide();
                                systemBaseEvent.syncExec("editorDataChange", res);
                                systemBaseEvent.syncExec("editorIdChange", {editorId: this.state.id});
                                let funs = window.ueditor.afterSaveDataFun;
                                for(let i = 0 ; funs && i < funs.length; i++){
                                    let fun = funs[i];
                                    if(fun instanceof Promise){
                                        await fun(activiti, res, call);
                                    }else{
                                        fun(activiti, res, call);
                                    }
                                }
                                this.securityCheckAsyncCheck({params, activiti, website:res, call});
                                this.updateProcessAndData(this.publishData);
                            } else {
                                message.error('保存失败！');
                                call && call(false);
                            }
                        },
                        errorCallBack: function (e) {
                            call && call(false);
                            message.error('保存失败！');
                        }
                    });
                } else {
                    window.loading.hide();
                    call && call(false);
                    return false
                }
            }
        });
        //   window.ueditor.editRefresh()
    };

    setPublish = (data) => {
    };
    getPublish = (data) => {
        return {}
    }

}